import { styled, css } from '@creditas/stylitas'
import { prop, ifProp } from 'styled-tools'

interface GridContainerProps {
  columnEqHeight?: {
    min: number
    max: number
  }
  size?: string
  verticalGap?: string
  horizontalGap?: string
  theme?: {
    mediaScreen: {
      tablet: string
      desktop: string
    }
  }
}

const GridContainer = styled.div<GridContainerProps>`
  width: 100%;

  ${ifProp(
    'columnEqHeight',
    `grid-template-rows: minmax(${prop(
      'columnEqHeight.min',
      'min-content',
    )}, ${prop('columnEqHeight.max', 'max-content')});`,
  )}

  ${ifProp(
    'keepWhenMobile',
    ({ size, verticalGap, horizontalGap, theme }) => css`
      display: grid;
      ${size
        ? `grid-template-columns: repeat(${size}, 1fr);`
        : `grid-template-columns: repeat(12, 1fr);`}
      grid-gap: ${verticalGap || '30px'} ${horizontalGap || '30px'};
      place-items: start start;

      & div {
        ${theme.mediaScreen.tablet} {
          margin-bottom: 0px;
        }
      }
    `,
    ({ theme, verticalGap, horizontalGap }) => css`
      ${theme.mediaScreen.desktop} {
        display: grid;
        grid-template-columns: repeat(12, 1fr);
        grid-gap: ${verticalGap || '30px'} ${horizontalGap || '30px'};
        place-items: start start;
      }
    `,
  )}
`

export { GridContainer }
